export default __webpack_public_path__ + "static/media/baby-28.47127d9c.svg";